export default __webpack_public_path__ + "static/media/TITULO_DISCO_14.66f0264d.png";